<script>
import { Cropper } from 'vue-advanced-cropper'

export default {
    components: {
        Cropper
    },
    data() {
        return {
            dataURL: null,
        }
    },
    props: {
        width: {
            required: false,
            default: '100%'
        },
        height: {
            required: false,
            default() {
                return window.innerHeight * 0.5
            }
        },
        text: {
            default: 'Upload Image'
        },
        title: {
            default: 'Upload Image'
        },
        size: {
            default: 'md'
        }
    },
    methods: {
        cropperUpload(e) {
            let input = event.target

            if (input.files && input.files[0]) {
                let reader = new FileReader()

                reader.addEventListener('load', (_e) => {
                    this.dataURL = _e.target.result
                    this.$emit('select', this.dataURL)
                    this.$refs.imageUploadModal.show()
                })

                reader.readAsDataURL(input.files[0])
            }
        },
        onCropperSave() {
            const { coordinates, canvas } = this.$refs.cropper.getResult()
            this.dataURL = canvas.toDataURL()
            this.$emit('success', this.dataURL)
        },
        onUploadClick() {
            this.$refs.file.click()
        }
    },
    mounted() {
        this.$refs.imageUploadModal.$on('hide', () => {
            this.$refs.file.value = ''
        })
    }
}
</script>

<template>
    <div>
        <slot name="button" :handler="onUploadClick">
            <b-button :size="size" @click="onUploadClick()">{{ text }}</b-button>
        </slot>
        <input type="file" ref="file" name="file" class="upload-input" @change="cropperUpload" accept="image/*" />
        <b-modal id="modal-image-upload" :title="title" ref="imageUploadModal" size="md" @ok="onCropperSave" no-fade centered>
            <cropper class="cropper-area" ref="cropper" :style="{ width, height }" :src="dataURL" :stencil-props="{ handlers: {}, movable: true, scalable: true, aspectRatio: 1 }"></cropper>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>
.cropper-area {
    border: solid 1px #eee;
    height: 100%;
    width: 100%;
}

.upload-input {
    display: none;
}
</style>
